var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoDivisao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-divisao",
    transform: "translate(-114 -1001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2187",
    "data-name": "Grupo 2187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2186",
    "data-name": "Grupo 2186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2185",
    "data-name": "Grupo 2185",
    transform: "translate(6 72.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "division",
    transform: "translate(114 913.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2184",
    "data-name": "Grupo 2184",
    transform: "translate(-1 20.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2183",
    "data-name": "Grupo 2183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1203",
    "data-name": "Caminho 1203",
    d: "M37.4,233.667H.67a1.67,1.67,0,1,0,0,3.339H37.4a1.67,1.67,0,0,0,0-3.339Z",
    transform: "translate(1 -216.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1204",
    "data-name": "Caminho 1204",
    d: "M176.345,33.69a6.678,6.678,0,1,0-6.678-6.678A6.678,6.678,0,0,0,176.345,33.69Zm0-10.018a3.339,3.339,0,1,1-3.339,3.339A3.339,3.339,0,0,1,176.345,23.672Z",
    transform: "translate(-156.31 -20.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1205",
    "data-name": "Caminho 1205",
    d: "M176.345,319a6.678,6.678,0,1,0,6.678,6.678A6.678,6.678,0,0,0,176.345,319Zm0,10.018a3.339,3.339,0,1,1,3.339-3.339A3.339,3.339,0,0,1,176.345,329.018Z",
    transform: "translate(-156.31 -295.626)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_441",
    "data-name": "Ret\\xE2ngulo 441",
    width: 50,
    height: 50,
    transform: "translate(114 1001)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoDivisao);
export default __webpack_public_path__ + "static/media/ico-funcao-divisao.8b5839f9e2bc072946f0bdd8f9309ecb.svg";
export { ForwardRef as ReactComponent };